import en from './strings.en';

const ru = {
    showContacts: 'Показать контакты',
    lastActive: 'Последний активный',
    mostActive: 'Самый активный',
    lastAndMostActive: 'Последний и Самый активный',
};

export default { ru, en: { ...ru, ...en} };
